import { createSlice } from '@reduxjs/toolkit';

export interface IAppProps {
  locale: string;
  currency: string;
  environment: string;
  ageRestricted: boolean;
  analyticsLoaded: boolean;
}

export interface IAppState extends IAppProps {
  initialized: boolean;
  loading: boolean;
  error: string;
}

const appSlice = createSlice({
  name: 'app',
  initialState: {
    ageRestricted: false,
    analyticsLoaded: false,
  },
  reducers: {
    setAgeRestricted(state, action) {
      state.ageRestricted = action.payload;
    },
    setAnalyticsLoaded(state, action) {
      state.analyticsLoaded = action.payload;
    },
  },
});

export const { setAgeRestricted, setAnalyticsLoaded } = appSlice.actions;

export default appSlice.reducer;
